<template>
  <div class="left-content">
    <div class="section-box box1">
      <div class="address-select box-style">
        <el-image :src="mapIcon" style="width: 20px; height: 20px"></el-image>
        <!-- <el-select v-model="selectAddress" >
    <el-option
      v-for="item in dataDetail.siteCityList"
      :key="item.moduleId"
      :label="item.stationName"
      :value="item.moduleId"
    >
    </el-option>
  </el-select> -->
        <span>江苏省苏州市​​</span>
      </div>
      <!-- <div class="message box-style">
        <el-image :src="mapIcon" style="width: 20px; height: 20px"></el-image>
        <span>27分钟后将下雨</span>
      </div> -->
    </div>
    <div class="section-box box2">
      <div class="weather box-style" v-if="weatherData">
        <div class="temperature-box">
          <div class="temperature">
            <div class="label">今日天气</div>
            <div class="value">
              <span class="value1">{{ weatherData.temperature }}</span>
              <span class="unit">℃</span>
            </div>
          </div>
          <el-image :src="weatherImage" style="width: 64px; height: 64px"></el-image>
        </div>
        <div class="weather-type">{{ weatherData.weather }}</div>
        <div class="weather-other">
          <div class="wind">{{ weatherData.winddirection }}风{{ weatherData.windpower }}级</div>
          <div class="humidity">湿度{{ weatherData.humidity }}%</div>
        </div>
      </div>
      <div class="list">
        <div class="list-item box-style" v-for="(item, i) in dataList" :key="i">
          <div class="name">{{ item.name }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import mapIcon from "@/assets/img/screen4-header-map.png";
import { ref, onMounted, computed, defineProps, watch } from "vue";
import { ElMessage } from "element-plus";
import { getGeneralWeatherApi } from "@/api/modules/project";
import cityCode from "@/assets/js/citycode";
const props = defineProps({
  dataDetail: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

let dataList = ref([
  { name: "正在预警中", value: 0, key: "alarmingNum" },
  { name: "本周累计预警", value: 0, key: "alarmingNumWeek" },
  { name: "本月累计预警", value: 0, key: "alarmingNumMonth" },
  { name: "近3个月累计预警", value: 0, key: "alarmingNumYear" },
]);
let weatherData = ref(null);
let getWeatherInfo = function () {
  new BMap.Geocoder().getLocation(new BMap.Point(120.199242, 30.289709), (result) => {
    if (result) {
      // console.log("详细地址：", result.address);
      let { province, city, district, street, streetNumber } = result.addressComponents;
      // 筛选出城市编码用于获取天气
      let code = cityCode.filter((item) => item.name === city)[0].adcode;
      getGeneralWeatherApi(code, "base")
        .then((res) => {
          if (res.data.status === "1") {
            weatherData.value = res.data.lives[0];
          } else {
            ElMessage({
              message: res.data.code,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.error("逆地理编码失败");
    }
  });
};
let weatherImage = computed(() => {
  let data = [
    {
      type: "晴",
      src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather1.png",
    },
    {
      type: "阴",
      src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather2.png",
    },
    {
      type: "多云",
      src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather2.png",
    },
    {
      type: "雨",
      src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather3.png",
    },
    {
      type: "雪",
      src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather4.png",
    },
  ];
  let src = "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather1.png";
  if (weatherData.value) {
    let type = weatherData.value.weather;
    let item = data.find((item) => item.type.includes(type));
    src = item ? item.src : src;
  }
  return src;
});

watch(
  () => props.dataDetail,
  (newValue) => {
    if (!newValue) return;
    dataList.value.forEach((item) => {
      item.value = newValue[item.key];
    });
  },
  { immediate: true }
);
onMounted(() => {
  getWeatherInfo();
});
</script>

<style lang="scss" scoped>
@font-face {
  font-family: OPPOSans B;
  src: url("https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/OPPOSans-B.ttf");
}
.left-content {
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 2;

  pointer-events: none; /* 整体允许点击穿透到下方 */
}
.box1 {
  display: flex;
  gap: 16px;
  .message {
    flex: 1;
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
      color: #333333;
      margin-left: 14px;
    }
  }
}
.address-select {
  display: flex;
  align-items: center;
  width: 200px;
  span {
    font-size: 14px;
    line-height: 14px;
    color: #333333;
    margin-left: 10px;
  }
}

.box2 {
  margin-top: 16px;
  width: auto;
}
.weather {
  width: 200px;
  .temperature-box {
    display: flex;
    justify-content: space-between;
    .temperature {
      display: flex;
      flex-direction: column;
      .label {
        font-size: 14px;
        color: #455464;
      }
      .value {
        display: flex;
        align-items: flex-start;
        .value1 {
          font-family: "OPPOSans B";
          font-weight: normal;
          font-size: 28px;
          color: #333333;
        }
        .unit {
          font-weight: 800;
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }
  .weather-type {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
  }
  .weather-other {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.list {
  width: 300px;
  display: flex;
  flex-direction: column;

  .list-item {
    width: 200px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .name {
      font-size: 14px;
      color: #455464;
    }
    .value {
      font-family: "OPPOSans B";
      font-weight: normal;
      font-size: 28px;
      color: #333333;
    }
  }
}

.box-style {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
  border-radius: 6px;
  padding: 14px 16px;
  box-sizing: border-box;
}
</style>
